import { AsyncStatus } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';
import { handleActions } from 'redux-actions';

import { sortEmailIntegrationsList } from 'utils/emailIntegration';

import { composeEmailActions } from '../actions/composeEmailActions';

export type ComposeEmailState = {
  meta: {
    findUser: AsyncStatus;
    getAllFrom: AsyncStatus;
  };
  fromEmails: FromEmail[];
  users: Array<User>;
};

export type FromEmail = {
  organization_id: string;
  queue_id: string | null;
  email_address: string;
  sender_name: string | null;
  spf_domain: string | null;
  spf_sender_email: string | null;
  signature_template: string | null;
  created_at: string;
  updated_at: string | null;
};

const initialState: ComposeEmailState = {
  meta: {
    findUser: 'succeeded',
    getAllFrom: 'succeeded',
  },
  fromEmails: [],
  users: [],
};

export const {
  composeEmailFindUser,
  composeEmailFindUserSucceeded,
  composeEmailFindUserFailed,
  composeEmailGetAllFrom,
  composeEmailGetAllFromSucceeded,
  composeEmailGetAllFromFailed,
} = composeEmailActions;

const composeEmail = handleActions<ComposeEmailState, any>(
  {
    [composeEmailFindUser.toString()]: (
      state: ComposeEmailState,
    ): ComposeEmailState => {
      return { ...state, meta: { ...state.meta, findUser: 'loading' } };
    },

    [composeEmailFindUserSucceeded.toString()]: (
      state: ComposeEmailState,
      action: any,
    ): ComposeEmailState => {
      const hits =
        action.payload.data !== undefined &&
        action.payload.data[0] !== undefined &&
        Array.isArray(action.payload.data[0].hits) === true
          ? action.payload.data[0].hits
          : [];
      const users = hits.filter(
        (user) =>
          user.email !== undefined &&
          user.email !== null &&
          typeof user.email === 'string',
      );
      return {
        ...state,
        meta: { ...state.meta, findUser: 'succeeded' },
        users: users,
      };
    },

    [composeEmailFindUserFailed.toString()]: (
      state: ComposeEmailState,
    ): ComposeEmailState => {
      return { ...state, meta: { ...state.meta, findUser: 'failed' } };
    },

    [composeEmailGetAllFrom.toString()]: (
      state: ComposeEmailState,
    ): ComposeEmailState => {
      return { ...state, meta: { ...state.meta, getAllFrom: 'loading' } };
    },

    [composeEmailGetAllFromSucceeded.toString()]: (
      state: ComposeEmailState,
      action: any,
    ): ComposeEmailState => {
      const data =
        action.payload.data !== undefined &&
        Array.isArray(action.payload.data) === true
          ? action.payload.data
          : [];

      return {
        ...state,
        meta: { ...state.meta, getAllFrom: 'succeeded' },
        fromEmails: sortEmailIntegrationsList(data),
      };
    },

    [composeEmailGetAllFromFailed.toString()]: (
      state: ComposeEmailState,
    ): ComposeEmailState => {
      return { ...state, meta: { ...state.meta, getAllFrom: 'failed' } };
    },
  },
  initialState,
);

export default composeEmail;
